<template>
  <div
    :grc_text="buttontext"
    :grc_width="buttonwidth"
    :grc_readonly="readonly"
    :grc_style="buttonstyle"
    :grc_buttonpos="buttonpos"
    :grc_padding="padding"
    :grc_textalign="textalign"
    :grc_fontsize="fontsize"
    :grc_lefticon="lefticon"
    :grc_righticon="righticon"

      v-bind:style="{ 'width':buttonwidth, 'display':'inline-block', 'box-sizing':'border-box' }"    

  >
    <button ref="button"
        :class="['grc-button', readonly=='true' ? 'grc-button-readonly' : '', buttonstyle]"

        @click="ButtonClick"
        @keydown="onInputKeydown"
    >
        <table style="width:100%;" cellspacing="0" cellpadding="0">
            <tr style="height: 100%;">
                <td style="width:1px;padding-left: 4px" v-html="lefticon"></td>
                <td v-bind:style="{'padding': padding, 'text-align':textalign, 'font-size': fontsize, 'line-height': fontsize}" v-html="buttontext">
                    
                </td>
                <td style="width:1px;padding-right: 4px" v-html="righticon"></td>
            </tr>
        </table>
        
        
    </button>

  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'GrcButton',
  components:
  {

  },
  props: {
    grc_text: String,
    grc_width: String,
    grc_readonly: String,
    grc_style: String,
    grc_buttonpos: String,
    grc_padding: String,
    grc_textalign: String,
    grc_fontsize: String,
    grc_lefticon: String,
    grc_righticon: String
  },
  data () {
    return {
        buttontext: this.grc_text,
        buttonwidth: this.grc_width,
        readonly: this.grc_readonly,
        buttonstyle: this.grc_style,
        buttonpos: this.grc_buttonpos,
        padding: this.grc_padding,
        textalign: this.grc_textalign,
        fontsize: this.grc_fontsize,
        lefticon: this.grc_lefticon,
        righticon: this.grc_righticon,

        comp_focused: false
    }
  },
  watch : {
  },

  created: function()
  {
    if (typeof this.buttontext == "undefined")
    {
      this.buttontext = "";
    }

    if (typeof this.buttonwidth == "undefined")
    {
      this.buttonwidth = "100%";
    }

    if (typeof this.padding == "undefined")
    {
      this.padding = "8px 8px";
    }

    if (typeof this.textalign == "undefined")
    {
      this.textalign = "center";
    }

    if (typeof this.fontsize == "undefined")
    {
      this.fontsize = "";
    }

    if (typeof this.lefticon == "undefined")
    {
      this.lefticon = "";
    }

    if (typeof this.righticon == "undefined")
    {
      this.righticon = "";
    }

    if (typeof this.buttonpos == "undefined")
    {
      this.buttonpos = "single";
    }

    if (typeof this.buttonstyle == "undefined")
    {
      this.buttonstyle = "";
    }


  },
  computed: {
  },
  methods: {

    SetLabel(pText)
    {
      this.buttontext = pText;
    },

    SetLeftIcon(pText)
    {
      this.lefticon = pText;
    },

    SetRightIcon(pText)
    {
      this.righticon = pText;
    },

    ButtonClick()
    {
        if (this.IsReadonly()) { return; }
        else {
            
            this.$emit('grc-click');
        }
    },


    onInputKeydown(e)
    {
      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.ButtonClick();
      }
    },

    SetFocus()
    {
      this.$refs.button.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    }



    
  }
}
</script>

<style scoped>

</style>